import { DEPENDENT_PISCS } from "../../../actions/types";
const initialState = {
  items: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case DEPENDENT_PISCS:
      return {
        ...state,
        items: action.payload
      };

    default:
      return state;
  }
}
